import React from 'react';
import { connect } from 'react-redux';
import { UPDATE } from 'admin-on-rest';
import {
  FlatButton,
  Dialog,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn,
  Subheader,
  ListItem,
  List,
  CircularProgress,
  Toggle,
} from 'material-ui';
import Sync from 'material-ui/svg-icons/notification/sync';
import Info from 'material-ui/svg-icons/action/info';
import Warning from 'material-ui/svg-icons/alert/warning';
import Error from 'material-ui/svg-icons/alert/error';
import { red500, yellow500, blue500, white } from 'material-ui/styles/colors';

import plz from 'await-plz';

import ErrorDialog from './ErrorDialog';
import { callApi } from '../client/apiToolbox';
import { kunal } from '../client';
import kunalClient from '../client/kunalClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);
const styles = {
  cell: { wordWrap: 'break-word', whiteSpace: 'normal' },
};

const tabs = ['missingCategoriesInJobOffice', 'insert', 'pause', 'failToInsert'];
const propertyStringMap = {
  SellPriceInclVat: 'Price',
  Description: 'Title',
  Advertisement: 'SubTitle',
  NeverDiscountThisArticle: 'No Bonus',
  insert: 'Insert products in JobOffice',
  pause: 'Pause products in JobOffice',
  failToInsert: 'Failed to insert products in JobOffice',
  missingCategoriesInJobOffice: 'Categories missing in JobOffice',
};

class SyncPreview extends React.Component {
  constructor() {
    super();
    this.state = {
      fetching: false,
      open: false,
      venueId: null,
      lang: null,
      errorOpen: null,
      err: null,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if ((!this.props.data && nextProps.data) || (this.props.data && !this.state.venueId)) {
      this.setState({
        version: nextProps.data.__v,
        venueId: nextProps.data.id,
        lang: nextProps.data.market.languageCodes[0],
        jobOfficeSyncState: nextProps.data.jobOfficeSync,
      });
    }
  };

  setJobOfficeSyncOnVenue = (venueId, jobOfficeSync) => {
    const { version } = this.state;
    this.setState({ fetching: true });
    restClient(UPDATE, 'venues', { id: venueId, data: { jobOfficeSync, __v: version } })
      .then(() => {
        this.setState({ jobOfficeSyncState: jobOfficeSync, fetching: false });
      });
  };

  fetchSync = async (venueId, lang, dryrun, successFn) => {
    this.setState({ fetching: true });
    const [err, res] = await plz(callApi(`${API_BASE_URL}/utils/jobofficesync/${venueId}?lang=${lang}&dryrun=${dryrun}&ratingThreshold=0.72`, 'POST'));

    console.log('err', err, 'res', res);

    if (err && err.data && err.data.json && err.data.json.message && err.data.json.message === 'localDryRun') {
      return this.setState({
        fetching: false,
        open: false,
        errorOpen: true,
        err: 'Developmental runs are disabled in back/server/controllers/ext/utils/jobofficeSync.js:6',
      });
    }
    if (err || !res || !res.success || !res.json || (res.json.statusCode && res.json.statusCode !== 200) || res.json.error) {
      console.log(
        'err', err,
        '!res', !res,
        '!res.success', res && !res.success,
        '!res.json', res && !res.json,
        'res.json.statusCode !== 200', res && res.json.statusCode !== 200,
        'res.json.error', res && res.json.error,
      );

      return this.setState({
        fetching: false,
        open: false,
        errorOpen: true,
        err: res && res.json ? res.json.error : 'Failed to reach JobOffice',
      });
    }

    if (successFn) successFn();
    return this.setState({ jobofficeSync: res.json, fetching: false, open: dryrun });
  };

  toggleErrorDialog = () => this.setState((state) => ({ errorOpen: !state.errorOpen }));

  toggle = () => {
    this.setState({ open: !this.state.open });
  };

  productUpdate = (data, prop, title) => (
    <ListItem
      disabled
    >
      <Subheader>{title}</Subheader>
      <Table
        multiSelectable
      >
        <TableHeader>
          <TableHeaderColumn>Product</TableHeaderColumn>
          <TableHeaderColumn>Property</TableHeaderColumn>
          <TableHeaderColumn>Old value</TableHeaderColumn>
          <TableHeaderColumn>New value</TableHeaderColumn>
        </TableHeader>
        <TableBody>
          {data.map((item) => item.diff.map((diff) => (diff.path[0] === prop &&
            (
              <TableRow>
                <TableRowColumn style={styles.cell}>{item.name}</TableRowColumn>
                <TableRowColumn
                  style={styles.cell}
                >{propertyStringMap[diff.path[0]] || diff.path[0]}
                </TableRowColumn>
                <TableRowColumn style={styles.cell}>{`${diff.lhs}`}</TableRowColumn>
                <TableRowColumn style={styles.cell}>{`${diff.rhs}`}</TableRowColumn>
              </TableRow>)),
          ))
          }
        </TableBody>
      </Table>
    </ListItem>
  );

  dialogActions = () => ([
    <FlatButton
      label="close"
      primary
      disabled={this.state.fetching}
      onClick={this.toggle}
    />,
    <FlatButton
      label={this.state.fetching ? 'syncing...' : 'sync'}
      disabled={this.state.fetching}
      primary
      onClick={() => this.fetchSync(this.state.venueId, this.state.lang, false, () => this.setJobOfficeSyncOnVenue(this.state.venueId, true))}
    />,
  ]);

  render() {
    const { open, jobofficeSync, errorOpen, err, jobOfficeSyncState } = this.state;

    return (
      <FlatButton
        onClick={() => this.fetchSync(this.state.venueId, this.state.lang, true)}
        primary
        label={jobOfficeSyncState ? 'Sync is active' : 'Sync'}
        disabled={this.state.fetching || this.state.open}
        icon={this.state.fetching ? <CircularProgress size={20} /> : <Sync />}
      >
        <Dialog
          open={open}
          onRequestClose={() => this.setState({ open: false })}
          actions={this.dialogActions()}
          autoDetectWindowHeight
          autoScrollBodyContent
          modal={false}
          style={{ paddingTop: 0, height: '100vh' }}
        >
          {jobofficeSync ?
            <List hoverColor={white}>
              <ListItem
                disabled
              >
                <Subheader>
                  <Toggle
                    label="Sync with JobOffice"
                    labelPosition="right"
                    onToggle={() => this.setJobOfficeSyncOnVenue(this.state.venueId, !jobOfficeSyncState)}
                    toggled={jobOfficeSyncState}
                    disabled={!jobOfficeSyncState && (jobofficeSync.missingCategoriesInJobOffice.length || jobofficeSync.update.length || jobofficeSync.pause.length || jobofficeSync.insert.length)}
                  />
                </Subheader>
                <Table
                  multiSelectable
                >
                  <TableBody>
                    <TableRow>
                      <TableRowColumn style={{ width: '10%' }}>
                        {jobofficeSync.missingCategoriesInJobOffice.length ? (
                          <Error color={red500} />) : (<Info color={blue500} />)}
                      </TableRowColumn>
                      <TableRowColumn>Categories in JobOffice</TableRowColumn>
                      <TableRowColumn>
                        {jobofficeSync.missingCategoriesInJobOffice.length ? `Missing: ${jobofficeSync.missingCategoriesInJobOffice.length}` : 'All categories match'}
                      </TableRowColumn>
                    </TableRow>
                    <TableRow>
                      <TableRowColumn style={{ width: '10%' }}>
                        {jobofficeSync.update.length ? (<Warning color={yellow500} />) : (
                          <Info color={blue500} />)}
                      </TableRowColumn>
                      <TableRowColumn>Updating products</TableRowColumn>
                      <TableRowColumn>
                        {jobofficeSync.update.length ? `${jobofficeSync.update.length} products` : 'Up to date'}
                      </TableRowColumn>
                    </TableRow>
                    <TableRow>
                      <TableRowColumn style={{ width: '10%' }}>
                        {jobofficeSync.pause.length ? (<Warning color={yellow500} />) : (
                          <Info color={blue500} />)}
                      </TableRowColumn>
                      <TableRowColumn>Pausing products</TableRowColumn>
                      <TableRowColumn>
                        {jobofficeSync.pause.length ? `${jobofficeSync.pause.length} products` : 'Up to date'}
                      </TableRowColumn>
                    </TableRow>
                    <TableRow>
                      <TableRowColumn style={{ width: '10%' }}>
                        {jobofficeSync.insert.length ? (<Warning color={yellow500} />) : (
                          <Info color={blue500} />)}
                      </TableRowColumn>
                      <TableRowColumn>Inserting new products</TableRowColumn>
                      <TableRowColumn>
                        {jobofficeSync.insert.length ? `${jobofficeSync.insert.length} products` : 'Up to date'}
                      </TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>
              </ListItem>

              {jobofficeSync.fuzzyMatches.length > 0 &&
              (
                <ListItem disabled>
                  <Subheader>Possible match</Subheader>
                  <Table multiSelectable>
                    <TableBody>
                      {jobofficeSync.fuzzyMatches.map((item) => (
                        <TableRow>
                          <TableRowColumn>{item.name}</TableRowColumn>
                          <TableRowColumn>{item.target}</TableRowColumn>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </ListItem>
              )}

              {tabs.map((tab) => {
                if (jobofficeSync[tab] && jobofficeSync[tab].length) {
                  return (
                    <ListItem
                      disabled
                    >
                      <Subheader>{propertyStringMap[tab]}</Subheader>
                      <Table
                        multiSelectable
                      >
                        <TableBody>
                          {jobofficeSync[tab].map((item) => (
                            <TableRow>
                              <TableRowColumn>{item.name}</TableRowColumn>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </ListItem>
                  );
                }
                return null;
              })}
              {jobofficeSync.update.length > 0 && this.productUpdate(jobofficeSync.update, 'SellPriceInclVat', 'Updated prices of products in JobOffice')}
              {jobofficeSync.update.length > 0 && this.productUpdate(jobofficeSync.update, 'HotValue', 'Preparation Station')}
              {jobofficeSync.update.length > 0 && this.productUpdate(jobofficeSync.update, 'BongHot', 'Hot Station')}
              {jobofficeSync.update.length > 0 && this.productUpdate(jobofficeSync.update, 'Description', 'Renamed products in JobOffice')}

            </List>
            : <h2>Waiting for sync</h2>}
        </Dialog>
        <ErrorDialog open={errorOpen} error={err} fn={this.toggleErrorDialog} />
      </FlatButton>
    );
  }
}

export default connect()(SyncPreview);
